var _rect, _rect2, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchIconWithBorder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 35,
    rx: 5.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 35,
    rx: 5.5,
    stroke: "#D8DFE5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3346 21.167L28.0846 24.917C28.418 25.2503 28.418 25.7503 28.0846 26.0837C27.918 26.2503 27.668 26.3337 27.5013 26.3337C27.3346 26.3337 27.0846 26.2503 26.918 26.0837L23.168 22.3337C21.918 23.2503 20.418 23.8337 18.7513 23.8337C14.8346 23.8337 11.668 20.667 11.668 16.7503C11.668 12.8337 14.8346 9.66699 18.7513 9.66699C22.668 9.66699 25.8346 12.8337 25.8346 16.7503C25.8346 18.417 25.2513 20.0003 24.3346 21.167ZM18.7513 11.3337C15.7513 11.3337 13.3346 13.7503 13.3346 16.7503C13.3346 19.7503 15.7513 22.167 18.7513 22.167C20.2513 22.167 21.5846 21.5837 22.5846 20.5837C23.5846 19.5837 24.168 18.2503 24.168 16.7503C24.168 13.7503 21.7513 11.3337 18.7513 11.3337Z",
    fill: "#828282"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25226_42659",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 9,
    width: 18,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3346 21.167L28.0846 24.917C28.418 25.2503 28.418 25.7503 28.0846 26.0837C27.918 26.2503 27.668 26.3337 27.5013 26.3337C27.3346 26.3337 27.0846 26.2503 26.918 26.0837L23.168 22.3337C21.918 23.2503 20.418 23.8337 18.7513 23.8337C14.8346 23.8337 11.668 20.667 11.668 16.7503C11.668 12.8337 14.8346 9.66699 18.7513 9.66699C22.668 9.66699 25.8346 12.8337 25.8346 16.7503C25.8346 18.417 25.2513 20.0003 24.3346 21.167ZM18.7513 11.3337C15.7513 11.3337 13.3346 13.7503 13.3346 16.7503C13.3346 19.7503 15.7513 22.167 18.7513 22.167C20.2513 22.167 21.5846 21.5837 22.5846 20.5837C23.5846 19.5837 24.168 18.2503 24.168 16.7503C24.168 13.7503 21.7513 11.3337 18.7513 11.3337Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25226_42659)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 8H30V28H10V8Z",
    fill: "#828282"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconWithBorder);
export default __webpack_public_path__ + "static/media/SearchIconWithBorder.e9fd9766345515de446b61a6d0884d8b.svg";
export { ForwardRef as ReactComponent };